import React from 'react';

const AuthInfoUploadIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3519_41659)">
        <path
          d="M11.9999 9.74981L8.74994 13.2498M11.9999 9.74981L15.2499 13.2498M11.9999 9.74981V12.7239V15.6979V21.6461M14.7937 15.6548C14.7937 15.6548 17.5987 15.7623 18.6924 15.2798C19.4554 14.9345 20.1143 14.3948 20.6031 13.7147C21.0919 13.0346 21.3934 12.2381 21.4774 11.4048C21.6412 9.76856 20.8949 7.97106 19.4849 7.10106C18.7837 6.66981 17.9649 6.49481 17.1462 6.42356C16.68 6.4101 16.2134 6.42973 15.7499 6.48231C15.4258 5.4492 14.8019 4.53577 13.9575 3.85804C13.113 3.18032 12.0862 2.7689 11.0074 2.67606C10.167 2.61512 9.32401 2.75443 8.54782 3.08255C7.77164 3.41067 7.08436 3.91823 6.54244 4.56356C6.0118 5.19805 5.6311 5.94406 5.42869 6.74606C5.37494 6.95856 5.26869 7.55106 5.26869 7.55106C4.72174 7.72697 4.21673 8.0133 3.78494 8.39231C2.47119 9.56731 2.15119 11.5748 2.88619 13.1548C3.55369 14.5898 4.98744 15.6548 6.58244 15.6548H9.20744"
          stroke="#08081B"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3519_41659">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.107422)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default AuthInfoUploadIcon;
